import * as models from '../../../../domain/models';
import * as dto from '../contracts';

export class PaymentTransactionWiredTransferDtoMapper {
  toDto(pt: models.PaymentTransactionWiredTransfer): dto.PaymentTransactionWiredTransferDto {
    return new dto.PaymentTransactionWiredTransferDto(
      pt.referenceNumber,
      pt.paymentDate,
      pt.paymentTransactionType
    );
  }
}
